module.exports = __webpack_public_path__ + "img/enchufe.c92fe881.svg";